import React, { Component } from 'react'
import Modal from "../../components/Modal";
import HttpServices from "../../utils/Http.services";
import ContextMenu from "./contextMenu";
import Uploader from "./uploadFiles";
import CustomLoader from "../../components/CustomLoader";
import { getBoundingClientRect } from "../../utils/functions";
import moment from "jalali-moment";
import { conditionalWidth, imageAddress, textVariableReplacer, translate } from "../../utils/useful";
import PropertiesView from "./DriveStages/PropertiesView";
import SidebarView from "../../components/SidebarView";
// import HeaderDrive from "./HeaderDrive";
import Dropzone from "react-dropzone";
import { nanoid } from "nanoid";
import DirectoryViewer from './DirectoryViewer';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import Templates from '../Templates';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import StagesManager from '../../components/StagesManager';
import { siteConfig } from '../../variables/config';
import ShareModal from '../../modals/ShareModal';
import FileSinglePage from './FileSinglePage';
import DriveSelectApplet from './DriveSelectApplet';
import DriveToolbar from './DriveToolbar';
import DirectoryPathIndicator from './DirectoryPathIndicator';
import FilePreview from './FilePreview';
import { saveAs } from "file-saver";

class FileManager extends Component {

    constructor(props) {
        super(props)
        this.contextMenu = React.createRef();
        this.state =
        {
            showConfig: false,
            percent: 0,
            showRecent: false,
            showContextMenu: false,
            deleteItem: false,
            rename: false,
            view: 'details',
            time: moment().format('YYYY-MM-DD h:mm:ss a'),
            contextMenu:
            {
                show: false,
                xPos: null,
                yPos: null,
                view: null
            },
            paths: [{ name: 'Drive', _id: null, link: null }],
            currentItem: "",
            driveInfo: [],
            copyItem: null,
            inputValue: "",
            file: '',
            Url: '',
            renameItem: null,
            filteredFiles: [],
            errorName: false,
            frame: '{{lang}}Explore',
            current: "",
            currentSort: { type: 'modifiedDate', mode: 'descending' },
            sorted: true,
            uploadingList: false,
            itemActions: [],
            exploreActions: {
                preview: { key: "preview", label: '{{lang}}preview', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openPreview", icon: "/assets/icons/useful/preview.svg", trashed: '*', type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.extension' }, operator: { value: 'in' }, target: { value: ['png', 'jpg', 'jpeg', 'svg', 'gif', 'mp4'] } }, } } },
                properties: { key: "properties", label: '{{lang}}drives.Properties', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onProperties", icon: "/assets/icons/applets/drive/circle.grid.cross.svg", trashed: '*', type: '*' },

                restore: { key: "restore", label: '{{lang}}drives.Restore', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "restoreFromTrash", icon: "/assets/icons/applets/drive/square.and.pencil.svg", trashed: true, type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.trashed' }, operator: { value: '==' }, target: { value: true } }, } } },

                openFolder: { key: "openFolder", label: '{{lang}}drives.Open folder', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onOpenItem", icon: "/assets/icons/applets/drive/open-folder.svg", trashed: false, type: 'folder', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "folder" } }, 2: { id: 2, source: { value: '@data.trashed' }, operator: { value: '!=' }, target: { value: true } } } } },
                copy: { key: "copy", label: '{{lang}}drives.Copy', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onCopyItem", icon: "/assets/icons/applets/drive/copy.svg", trashed: false, type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.trashed' }, operator: { value: '!=' }, target: { value: true } }, } } },
                rename: { key: "rename", label: '{{lang}}drives.Rename', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onRenameItem", icon: "/assets/icons/applets/drive/square.and.pencil.svg", trashed: false, type: '*', },
                locked: { key: "locked", label: '{{lang}}Set password', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "lockModal", icon: "/assets/icons/lock.svg", trashed: false, type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.trashed' }, operator: { value: '!=' }, target: { value: true } }, } } },
                share: { key: "share", label: '{{lang}}drives.Share', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openShareModal", icon: "/assets/icons/useful/share.png", trashed: false, type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.trashed' }, operator: { value: '!=' }, target: { value: true } }, } } },

                starred: { key: "starred", label: "{{lang}}Make starred", color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onStar", icon: "/assets/icons/useful/star (9).png", conditionIcon: "/assets/icons/applets/drive/starred-fill.svg", trashed: false, type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.trashed' }, operator: { value: '!=' }, target: { value: true } }, 2: { id: 2, source: { value: '@data.starred' }, operator: { value: '!=' }, target: { value: true } }, } } },
                unstarred: { key: "unstarred", label: "{{lang}}Remove star", color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onStar", icon: "/assets/icons/useful/star (9).png", conditionIcon: "/assets/icons/applets/drive/starred-fill.svg", trashed: false, type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.trashed' }, operator: { value: '!=' }, target: { value: true } }, 2: { id: 2, source: { value: '@data.starred' }, operator: { value: '==' }, target: { value: true } } } } },

                copyLink: { key: "copyLink", label: '{{lang}}Copy link', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "copyLink", icon: "/assets/icons/useful/link-alt.svg", trashed: false, type: 'folder', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.trashed' }, operator: { value: '!=' }, target: { value: true } }, } } },
                download: { key: "download", label: '{{lang}}Downlaod', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "downloadFile", icon: "/assets/icons/useful/cloud-download.svg", trashed: false, type: 'folder', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "file" } }, } } },
                trash: { key: "trash", label: "{{lang}}drives.Trash", color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onDeleteItem", icon: "/assets/icons/messenger/trash.svg", trashed: false, type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.trashed' }, operator: { value: '!=' }, target: { value: true } }, } } },

                delete: { key: "delete", label: '{{lang}}Permanent delete', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onDeleteItem", icon: "/assets/icons/messenger/trash.svg", trashed: true, type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.trashed' }, operator: { value: '==' }, target: { value: true } }, } } },

            },

            // trashedActions: {
            //     preview: { key: "preview", label: '{{lang}}preview', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openPreview", icon: "/assets/icons/useful/preview.svg", trashed: '*', type: '*', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.extension' }, operator: { value: 'in' }, target: { value: ['png', 'jpg', 'jpeg', 'svg', 'gif', 'mp4'] } }, } } },
            //     properties: { key: "properties", label: '{{lang}}drives.Properties', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onProperties", icon: "/assets/icons/applets/drive/circle.grid.cross.svg", trashed: '*', type: '*' },
            //     restore: { key: "restore", label: '{{lang}}drives.Restore', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "restoreFromTrash", icon: "/assets/icons/applets/drive/square.and.pencil.svg", trashed: true, type: '*' },
            //     download: { key: "download", label: '{{lang}}Downlaod', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "downloadFile", icon: "/assets/icons/useful/cloud-download.svg", trashed: false, type: 'folder', conditions: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: "file" } }, } } },
            //     delete: { key: "delete", label: '{{lang}}drives.Delete', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "onDeleteItem", icon: "/assets/icons/messenger/trash.svg", trashed: true, type: '*' },
            // },
            link: '',
            newFolder: false,
            newUpload: false,
            isLoadingData: false,
            newFolderModal: false,
            showDirectory: false,
            viewType: { key: 'explore', label: '{{lang}}Explore', icon: '/assets/icons/applets/drive/folder-orange.svg', icon2: '/assets/icons/applets/drive/all-files-3.svg' },
            driveSections: [
                { key: 'explore', label: '{{lang}}Explore', icon: '/assets/icons/applets/drive/folder-orange.svg', icon2: '/assets/icons/applets/drive/all-files-3.svg' },
                { key: 'starred', label: '{{lang}}Starred', icon: '/assets/icons/applets/drive/starred1.svg', icon2: '/assets/icons/applets/drive/starred-orange.svg' },
                { key: 'trashed', label: '{{lang}}Trash', icon: '/assets/icons/applets/drive/trash-orange-2.svg', icon2: '/assets/icons/applets/drive/trash-orange.svg' },
                { key: 'sharedWithMe', label: '{{lang}}Shared With Me', icon: '/assets/icons/applets/drive/trash-orange-2.svg', icon2: '/assets/icons/applets/drive/trash-orange.svg' },
            ]
        }
        this.inputFolder = React.createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleSubmit(evt) {
        evt.preventDefault();
    }

    handleInputChange(files) {
        let paths = this.state.paths
        let uploadList = this.state.uploadingList ?? []
        uploadList = [uploadList, ...files]
        this.setState({ uploadList });
        files.forEach(file => {
            HttpServices.addUploadQueque(file, { folder: paths[paths.length - 1]._id, type: 'drive', drive: '123' }, nanoid(), (fetchResult, fetchError) => {
                this.getFiles()
                this.hideUploadModal()
            })
        })
    }

    // functionsHandler = (type, name, data, extra) => {
    //     if (this[name]) {
    //         this[name](data, extra)
    //     }
    // }


    componentDidMount = () => {
        document.addEventListener("keydown", this._handleKeyDown);

        if (this.props.applet || (this.props.currentApplet && this.props.appletSelected)) {
            if (this.stageManager) {

                this.stageManager.changeStage('directoryViewer')
            }
        }
        // if (this.props.windowData.path.length != 1) {
        if (this.stageManager) {
            this.stageManager.changeStage('directoryViewer')
        }
        this.setState({ showDirectory: true })
        this.setViewType(this.props.windowData.params?.view)
        // }
        // this.getFiles(true)
        document.addEventListener('click', () => {
            let { contextMenu } = this.state;
            contextMenu.show = false;
            this.setState({
                contextMenu: contextMenu, current: ""
            })
        })
        this.closeContextMenu()

        if (this.props.setHeader) {

            if (this.props.currentApplet == '') {
                this.setState({ hideNew: true })
            } else {
                this.setState({ hideNew: false })
            }
            this.props.setHeader({
                'toolbar': this.toolbarView,
                'navbarComponent': this.navbarComponent,

                'showToolbar': true,
                'showFrames': true,
                'showSettings': this.props.isApplet,
                // 'pathNavbar': this.state.paths,
                onChangeDirectory: this.onChangeDirectory,
                // isPortal: !this.props.isApplet,
                // title: !this.props.isApplet && '{{lang}}Drive',
                // type: 'drive'
            })
            // if (this.props.currentApplet == '') {
            // } else {
            //     this.props.setHeader(obj)

            // }
        }
    }

    toolbarView = () => {
        return (
            <DriveToolbar ref={el => { this.driveToolbar = el }}
                colors={this.props.colors}
                language={this.props.language}
                width={this.props.width}
                currentSort={this.state.currentSort}
                currentApplet={this.props.currentApplet}
                frame={this.state.frame}
                currentAppletName={this.props.currentAppletName}
                setStateProps={this.setStateProps}
                sortList={this.sortList}
                changeFrame={this.changeFrame}
                setCurrentApplet={this.setCurrentApplet}
                openTemplatesModal={this.openTemplatesModal}
                setData={this.setData}
                openNote={this.openNote}
                createDoc={this.createDoc}
                isApplet={this.props.isApplet}
                applet={this.props.applet}
                changePage={this.props.changeStagePage}
                functionsHandler={this.functionsHandler}
                driveSections={this.state.driveSections}
                viewType={this.state.viewType}
            />
        )
    }





    navbarComponent = () => {
        return (
            <DirectoryPathIndicator paths={this.state.paths} onChangeDirectory={this.props.config?.onChangeDirectory} language={this.props.language} changeNav={this.props.changeNav} viewType={this.state.viewType} />
        )
    }



    functionsHandler = (type, name, data, extra, cb) => {

        // console.log(type, name, data, extra)

        if (!type || type == 'frame' || type == 'collection') {

            if (this[name]) {
                this.setState({ currentItem: data }, () => {
                    this[name](data, extra, cb)
                })
            }
        } else {
            this.props.functionsHandler(type, name, data, extra, cb)
        }
    }


    onRightClickItem = (event, item, type) => {
        let currentItem = item;
        let current = item;
        let corner = getBoundingClientRect(this.cornerDiv)
        this.setState({
            showContextMenu: true,
            contextMenu: {
                xPos: event.pageX - corner.left,
                yPos: event.pageY - corner.top,
                show: true,
                view: type
            },
            currentItem, current
        }, () => {
        })
    }


    changeView = (key) => {

        let params = { view: key }
        if (key == 'explore') {
            params = null
        }

        // console.log(this.props.changeWindow)

        this.props.changeWindow(this.props.windowData.path, params)

    }



    openSelectAppletModal = () => {
        if (this.driveToolbar && this.driveToolbar.selectApplet) {
            this.driveToolbar.selectApplet.appletViewModal.open()
        }
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    componentDidUpdate(prevProps, prevState) {

        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {


            if (this.props.applet || (this.props.currentApplet && this.props.appletSelected)) {
                if (this.stageManager) {
                    this.stageManager.changeStage('directoryViewer')
                }
                this.setState({ showDirectory: true })
                // if (this.stageManager && this.stageManager.state && this.stageManager.state.stage && this.stageManager.state.stage == 'directoryViewer') {
                //     this.closeContextMenu()
                // }
            }
            // this.getFiles()
            this.setViewType(this.props.windowData.params?.view)

            // if ((JSON.stringify(this.props.currentApplet) != JSON.stringify(prevProps.currentApplet)) && (JSON.stringify(this.props.currentApplet).trim() == null)) {
            //     this.stageManager.changeStage('')
            // }
        }
        if ((JSON.stringify(this.props.currentApplet) != JSON.stringify(prevProps.currentApplet)) && this.props.currentApplet == '') {
            let paths = []
            this.setState({ paths }, () => {
                this.props.setData('paths', paths, 'Drive')

            })
        }

        if ((JSON.stringify(this.props.windowData.params?.view) != JSON.stringify(prevProps.windowData.params?.view))) {

            this.setViewType(this.props.windowData.params?.view)
            // console.log(this.props.windowData.params)
        }

        // // TO DO: this may be called unwanted times, needs to be checked
        // if (((this.props.currentApplet) != (prevProps.currentApplet)) && (prevProps.currentApplet).length == 0) {
        //     // if (this.props.setHeader) {
        //     //     this.props.setHeader({
        //     //         'toolbar': this.toolbarView,
        //     //         'showToolbar': true,
        //     //         'showFrames': true,
        //     //         'showSettings': this.props.isApplet,
        //     //         'pathNavbar': this.state.paths,
        //     //         onChangeDirectory: this.onChangeDirectory,
        //     //         isPortal: !this.props.isApplet,
        //     //         title: !this.props.isApplet && '{{lang}}Drive',
        //     //         type: 'drive'
        //     //     })
        //     // }
        //     this.getFiles(true)
        // }
        if (((this.props.currentApplet) != (prevProps.currentApplet)) && (this.props.currentApplet).length == 0) {
            if (this.stageManager) {

                this.stageManager.changeStage('')
            }
            this.setState({ showDirectory: false })

        }
        if (JSON.stringify(this.props.page) != JSON.stringify(prevProps.page)) {
            this.getFiles(true)

        }

        // if (this.state.contextMenu && this.state.contextMenu.show == true) {
        //     document.addEventListener('scroll', () => {
        //         let { contextMenu } = this.state;
        //         contextMenu.show = false;
        //         this.setState({
        //             contextMenu: contextMenu, current: ""
        //         })
        //     })
        //     this.closeContextMenu()
        // }
    }

    _handleKeyDown = (e) => {
        if (this.state.newFolderModal) {
            if (e.key === 'Enter') {
                this.createDirectory();
                this.setState({ errorName: false })
            }
        }
    }

    closeContextMenu = () => {
        const actions = {
            click: 'click',
            scroll: 'scroll'
        }
        Object.keys(actions).forEach(key => {
            if (this.container) {

                this.container.addEventListener(key, (e) => {
                    let inside = e.target.closest('.context-close')
                    if (this.state.showContextMenu && !inside) {
                        this.setState({ showContextMenu: false, current: {} })
                    }
                    if (this.state.rename) {
                        this.setState({ renameItem: null, current: {} })
                    }
                    let renameInside = e.target.closest('.renameInput')
                    if (key == 'click' && this.state.renameItem && !renameInside) {
                        this.setState({ renameItem: null, current: {} })
                    }
                })
            }
            if (this.scrollContainer) {
                if (this.state.showDirectory) {


                    this.scrollContainer.addEventListener(key, (e) => {
                        let inside = e.target.closest('.context-close')
                        if (this.state.showContextMenu && !inside) {
                            this.setState({ showContextMenu: false, current: {} })
                        }
                        if (this.state.rename) {
                            this.setState({ renameItem: null, current: {} })
                        }
                        let renameInside = e.target.closest('.renameInput')
                        if (key == 'click' && this.state.renameItem && !renameInside) {
                            this.setState({ renameItem: null, current: {} })
                        }
                    })
                }
            }
        })
    }

    deleteConfirmation = () => {
        let frameCheck = this.state.frame.replace('{{lang}}', '')
        if (frameCheck == 'trashed' || frameCheck == 'Trash') {
            this.setState({ deleteItem: true })
        }
        this.confirmMoveToTrashModal.showModal()
        this.setState({ showContextMenu: false })
    }

    moveToTrash = (trash) => {
        console.log("moveToTrash")
        this.setState({
            showContextMenu: false, current: ""
        })
        const { currentItem } = this.state;
        if (currentItem == null) {
            return;
        }
        this.confirmMoveToTrashModal.hideModal();
        this.setState({ showContextMenu: false })
        let body = { _id: currentItem._id }
        let frameCheck = this.state.frame.replace('{{lang}}', '')


        if ((frameCheck == 'Trash' || frameCheck == 'trashed') && this.state.deleteItem) {

            console.log(body)

            HttpServices.request('removedFile', body, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                this.setState({ deleteItem: false })
                this.getFiles()
            })
        }
        else {
            body.trash = trash

            console.log(body)

            HttpServices.request('trashedFile', body, (fetchResult, fetchError) => {
                if (fetchError) {
                }
                if (fetchResult?.success === true) {
                    this.getFiles()
                }
            })
        }
    }

    getFiles = (init, cb) => {

        // console.log("getFiles")

        let { viewType } = this.state;
        let paths = this.props.paths
        // let { currentApplet } = this.props;
        // if (currentApplet != '' || this.props.applet) {

        let driveInfo = []
        let folder
        this.setState({ isLoadingFiles: true })
        // console.log('this.props.baseUrl.lengthch',this.props.baseUrl.length)
        if ((['explore', 'trashed', 'starred'].includes(viewType?.key)) && !this.props.windowData.path[this.props.baseUrl.length]) {
            paths = []
            this.setState({ paths }, () => {
                this.props.setData('paths', paths, 'Drive')
            })
            // directoryPath = null
        }
        else {
            if (this.props.windowData.path?.length > this.props.baseUrl?.length) {

                folder = this.props.windowData.path[this.props.baseUrl?.length]
                if (folder == 'folder') {
                    folder = this.props.windowData.path[this.props.baseUrl?.length + 1]
                }

            }
            // this.props.windowData.path[this.props.baseUrl.length]
        }
        // if (init) {
        //     directoryPath = (this.props.windowData && Array.isArray(this.props.windowData.path) && this.props.windowData.path[this.props.baseUrl.length]) ? this.props.windowData.path[this.props.baseUrl.length] : null
        // }
        // let applet = currentApplet ? (currentApplet?._id ?? currentApplet) : this.props.applet._id

        // console.log("getFiles 0", { type: this.state.viewType, folder: directoryPath, applet: applet, frame: this.props.page?._id, file: this.props.windowData.path[this.props.baseUrl.length + 1] })
        let body = {
            type: this.state.viewType?.key,
            folder: folder,
            // applet: applet,
            frame: this.props.page?._id,
            file: this.props.windowData.path[this.props.baseUrl.length + 1]
        }

        // console.log("this.props.windowData.path",this.props.windowData.path)
        // console.log("this.props.baseUrl",this.props.baseUrl)

        // console.log("paths",paths)
        // console.log("directoryPath",directoryPath)
        // console.log(this.props.windowData.path, this.props.baseUrl)
        // console.log("body", body)

        HttpServices.request('getFiles', body, (fetchResult, fetchError) => {

            // console.log("getFiles",fetchResult)

            if (fetchResult.folder && this.props.setCurrentFrame) {
                this.props.setCurrentFrame(fetchResult.folder)
            }

            this.setState({ isLoadingFiles: false })
            if (fetchError) {
                if (paths.length > 0) {
                    paths.pop()
                }
                return
            }
            if (fetchResult.folder) {
                let newPath = []
                fetchResult.folder?.parents?.forEach((element) => {
                    newPath.push({ name: element.name, _id: element._id, link: element.link })
                })

                newPath.push({ name: fetchResult.folder.name, _id: fetchResult.folder._id, link: fetchResult.folder.link })
                paths = newPath
            }
            // if (fetchResult.file && fetchResult.file.extension == 'ydoc') {
            //     this.props.setData('currentNote', fetchResult.file, 'Drive', () => {
            //         this.props.getNote()
            //     })
            // }

            // console.log(paths)
            if (this.props.setHeader) {
                // this.props.setHeader({
                //     'toolbar': this.toolbarView,
                //     'showToolbar': true,
                //     'showFrames': true,
                //     'showSettings': this.props.isApplet,
                //     'pathNavbar': paths,
                //     onChangeDirectory: this.onChangeDirectory,
                //     isPortal: !this.props.isApplet,
                //     title: !this.props.isApplet && '{{lang}}Drive',
                //     type: 'drive'
                // })
                this.setState({ paths }, () => {
                    this.props.setHeader('paths', paths)
                })
            }


            // if (this.props.currentApplet == '') {
            //     if (this.state.viewType?.key == 'explore') {
            //         fetchResult.info.forEach(element => {
            //             if (element && !element?.trashed || element?.trashed == false) {
            //                 driveInfo.push(element)
            //             }
            //         });
            //     }
            //     else if (this.state.viewType?.key == 'trashed') {
            //         fetchResult.info.forEach(element => {
            //             if (element && element.trashed == true) {
            //                 driveInfo.push(element)
            //             }
            //         });
            //     }
            //     else if (this.state.viewType?.key == 'starred') {
            //         fetchResult.info.forEach(element => {
            //             if (element && element.starred == true && element.trashed == false) {
            //                 driveInfo.push(element)
            //             }
            //         })
            //     }
            // }
            // else {
            //     if (this.state.viewType?.key == 'explore') {
            //         fetchResult.info.forEach(element => {
            //             let applet = element?.applet?._id ?? element?.applet
            //             if (element && (!element.trashed || element.trashed == false)) {
            //                 driveInfo.push(element)
            //             }
            //         });
            //     }
            //     else if (this.state.viewType?.key == 'trashed') {
            //         fetchResult.info.forEach(element => {
            //             let applet = element?.applet?._id ?? element?.applet

            //             if (element && element.trashed == true) {
            //                 driveInfo.push(element)
            //             }
            //         })
            //     }
            //     else if (this.state.viewType?.key == 'starred') {
            //         fetchResult.info.forEach(element => {
            //             let applet = element?.applet?._id ?? element?.applet

            //             if ((element.starred == true && element.trashed == false)) {
            //                 driveInfo.push(element)
            //             }
            //         })
            //     }
            // }

            driveInfo = fetchResult.info
            // console.log("driveInfo",driveInfo)

            this.setState({ driveInfo, folderInfo: fetchResult.folder, filteredFiles: driveInfo, paths }, () => {
                this.props.setData('paths', paths, 'Drive')

                if (cb) {
                    cb()
                }
            })
        })
        // } else {

        //     if (this.props.setHeader) {
        //         this.props.setHeader({
        //             'toolbar': this.toolbarView,
        //             'showToolbar': true,
        //             'showFrames': true,
        //             'showSettings': this.props.isApplet,
        //             'pathNavbar': paths,
        //             onChangeDirectory: this.onChangeDirectory,
        //             isPortal: this.props.isPortal,
        //             title: !this.props.isApplet && '{{lang}}Drive',
        //             type: 'drive'
        //         })
        //     }
        // }

    }


    getSharedFiles = (init, cb) => {


        let { viewType } = this.state;
        // let paths = this.props.paths
        let applet = this.props.applet ? this.props.applet._id : this.props.currentApplet
        let driveInfo = []
        let directoryPath = []
        this.setState({ isLoadingFiles: true })
        HttpServices.request('getSharedFiles', { applet: applet, file: this.props.windowData.path[3] }, (fetchResult, fetchError) => {
            // viewType = 'sharedWithMe'
            this.setState({ isLoadingFiles: false })
            if (fetchError) {
                // if (paths.length > 1) {
                //     paths.pop()
                // }
                return
            }
            if (fetchResult.file && fetchResult.file.extension == 'ydoc') {
                this.props.setData('currentNote', fetchResult.file, 'Drive', () => {
                    // this.props.getNote()
                })
            }
            if (this.props.setHeader) {
                this.props.setHeader({
                    'toolbar': this.toolbarView,
                    'showToolbar': true,
                    'showFrames': true,
                    'showSettings': this.props.isApplet,
                    // 'pathNavbar': paths,
                    onChangeDirectory: this.onChangeDirectory,
                    isPortal: !this.props.isApplet,
                    title: !this.props.isApplet && '{{lang}}Drive',
                    type: 'drive'
                })
            }
            if (this.props.currentApplet == '') {
                fetchResult.info.forEach(element => {
                    if (!element.trashed || element.trashed == false) {
                        driveInfo.push(element)
                    }
                });

            }
            else {
                fetchResult.info.forEach(element => {
                    let applet = element?.applet?._id ?? element?.applet
                    if ((!element.trashed || element.trashed == false) && (applet == this.props.currentApplet)) {
                        driveInfo.push(element)
                    }
                });
            }
            this.setState({ driveInfo, filteredFiles: driveInfo, viewType }, () => {
                if (cb) {
                    cb()
                }
            })
        })
    }


    updateFile = (info) => {
        let driveInfo = this.state.driveInfo
        let filteredFiles = this.state.filteredFiles
        let currentItem = info
        filteredFiles.map((element, index) => {
            if (element._id == info._id) {
                filteredFiles[index] = info
            }
        })
        driveInfo.map((element, index) => {
            if (element._id == info._id) {
                driveInfo[index] = info
            }
        })
        this.setState({ driveInfo, filteredFiles, currentItem })
    }
    checkName = (name, index, cb) => {
        if (!index) {
            index = 1
        }
        let driveInfo = this.state.driveInfo
        let found = false
        let driveName = index == 1 ? name : name + String(index - 1)
        for (let i = 0; i < driveInfo.length; i++) {
            if (driveInfo[i].name == driveName) {
                found = true
            }
        }
        if (found == true) {
            this.checkName(name, index + 1, cb)
        }
        else {
            if (index > 1) {
                name = name + String(index - 1)
            }
            cb(name)
        }
    }

    createDirectory = () => {
        let name = this.state.inputValue
        let applet = (this.props.currentApplet != '' && this.props.currentApplet) ? this.props.currentApplet : this.props.applet?._id

        // console.log("name",name,applet)

        let body = { name: name, type: "folder", folder: this.state.paths[this.state.paths.length - 1]?._id, applet: (applet?._id ?? applet), frame: this.props.page?._id }

        console.log("body", body)

        this.checkName(name, 1, (resultName) => {
            body.name = resultName
            HttpServices.request('addFile', body, (fetchResult, fetchError) => {
                if (fetchError) {
                    if (fetchError?.issueType == 'name') {
                        this.setState({ errorName: true })
                    }
                    return;
                }
                this.createNewFoldermodal.hideModal();
                this.getFiles()
                this.setState({ inputValue: "" })
            })
        })
    }

    onPasteItem = () => {
        this.setState({
            showContextMenu: false, current: ""
        })
        const { copyItem, paths } = this.state;
        if (copyItem === null) {
            this.setState({ copyItem: null })
            return;
        }
        let body = { folder: paths[paths.length - 1]._id, _id: copyItem };
        HttpServices.request('copy', body, (fetchResult, fetchError) => {
            this.setState({ copyItem: null })
            if (fetchError) { }
            if (fetchResult) { }
            this.getFiles()
            this.setState({ current: "" })
        })
    }

    changeInputValue = (e) => {
        this.setState({ inputValue: e.target.value })
    }

    onDeleteModal = () => {
        this.confirmMoveToTrashModal.showModal();
        this.setState({ showContextMenu: false })
    }

    folderModal = () => {
        this.createNewFoldermodal.showModal();
        this.setState({ newFolderModal: true, showContextMenu: false, errorName: false, current: "", newFolder: false })
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'FileManager') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, cb)
            }
        }
    }

    uploadModal = () => {
        // if (this.state.currentApplet == '') {
        //     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.Action Fail', description: 'Please select applet first' })
        // }
        // else {
        this.setState({ upload: true, newUpload: false })
        this.uploadingmodal.showModal();
        // }
    }

    hideUploadModal = () => {
        this.setState({ upload: false })
        this.uploadingmodal.hideModal()
    }

    openShareModal = (item) => {
        let currentItem = (this.state.currentItem && this.state.currentItem != '') ? this.state.currentItem : item
        this.setLink(currentItem, () => {
            this.shareModal.showModal()
        })
        // this.sharingModal.showModal();
    }

    openTemplatesModal = () => {
        this.templatesModal.showModal();
    }

    lockModal = () => {
        this.lockingModal.showModal();
    }

    onStar = (item) => {
        this.setState({
            showContextMenu: false, current: ""
        })
        let body = item
        body.starred = !item.starred
        body.frame = this.props.page?._id
        HttpServices.request('addFile', body, (fetchResult, fetchError) => {
            if (fetchError) {
            }
            this.setState({ starred: !this.state.starred })
            this.getFiles();
        })
    }



    onShowRecents = () => {
        this.setState({ showRecent: true })
    }

    onRename = (item, newName) => {
        // this.setState({ renameItem: item._id })
        let body = { name: newName, _id: item._id, type: item.type, folder: this.props.paths[this.props.paths.length - 1]._id }
        body.applet = (this.props.currentApplet != '' && this.props.currentApplet) ? this.props.currentApplet : this.props.applet._id
        body.frame = this.props.page?._id
        let renameItem = item

        HttpServices.request('addFile', body, (fetchResult, fetchError) => {
            if (fetchResult) {
                renameItem.name = fetchResult.info.name
                this.setState({ renameItem, rename: false, currentItem: "", current: "" }, () => {
                    this.setState({ renameItem: null })
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}Rename successfully' })
                })
            }
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.Rename unsuccessful', description: fetchError.message })
            }
        })
    }


    downloadFile = (fullData, extra, info) => {
        // let file = 'test.png'
        let data = textVariableReplacer(fullData, fullData.address, '', 'downloaaaad')
        if (Array.isArray(this.props.params)) {
            for (let i = 0; i < this.props.params.length; i++) {
                const param = this.props.params[i];
                data = textVariableReplacer(param?.info, data, param.fields, param.label)

            }
        }
        // console.log('downloading...',data)
        saveAs(imageAddress(data))
    }


    copyLink = (data) => {

        let link = siteConfig.rootDomain + "drive/" + data.type + '/' + data.link

        if (data.type == 'file' && data.extension == 'ydoc') {

            link = siteConfig.rootDomain + "drive/doc/" + data.link

        }
        navigator.clipboard.writeText(link);
        this.props.actions.addNotif({ type: 'success', title: 'Successfuly Copied!', description: 'Information Successfuly Copied.' })
    }


    onChangeDirectory = (path_index) => {
        // console.log("onChangeDirectory")
        this.stageManager.changeStage('directoryViewer')
        this.setState({ showDirectory: true })
        let { paths } = this.state;
        if (path_index === paths.length - 1) {
            return;
        }
        // paths = paths.slice(0, path_index + 1)

        console.log("paths", paths)

        this.setState({ paths: paths }, () => {
            this.props.setData('paths', paths, 'Drive')

            let newLink
            newLink = this.props.baseUrl.splice(2, 1)
            if (!this.props.applet && this.props.currentApplet != '') {
                newLink.push(this.props.currentApplet)
            }
            newLink.push(this.props.page._id)
            let path = []
            paths.forEach(el => {
                if (el._id != null) {
                    path = [el.link]
                    // path.push(el._id)
                }
            });
            if (paths[paths.length - 1].link) {
                newLink.push(paths[paths.length - 1].link)
            }
            // this.props.changeWindowLink(path)

            this.props.changeWindowLink(newLink)
            setTimeout(() => {
                this.getFiles()
            }, 100);
        })
    }

    onClickItem = (item) => {
        // console.log(item)
        if (item.type == 'folder' && this.state.viewType?.key != 'trashed') {



            let newLink
            // console.log('firstnewLink', this.props.baseUrl)
            // newLink = this.props.baseUrl.splice(2, 1)
            // console.log('firstnewLink', newLink)
            // if (!this.props.isApplet) {
            //     newLink.push(item.applet?._id ?? item.applet)
            // }
            // newLink.push(this.props.page._id)
            // let tmp = this.state.paths;
            // let link = this.state.paths;
            // if (link[0].name != 'Drive' && link[0]._id == null) {
            //     link.push({ name: 'Drive', _id: null, link: null })
            // }
            // link.push({ name: item.name, _id: item._id, link: item.link })
            // tmp = [{ name: item.name, _id: item._id, link: item.link }]
            this.setState({
                // paths: link,
                currentItem: item,
                showContextMenu: false,
                current: ""
            },
                () => {
                    // this.props.setData('paths', this.state.paths, 'Drive')

                    // let path = []
                    // tmp.forEach(el => {
                    //     if (el._id != null) {
                    //         // path.push(el._id)
                    //         path = [el.link]
                    //         // newLink.push(el.link)
                    //     }
                    // });

                    // console.log("baseUrl", [...this.props.baseUrl])

                    // newLink = [...this.props.baseUrl]
                    newLink = ['folder']
                    newLink.push(item.link)

                    // console.log("newLink", newLink)
                    // console.log("link", link)
                    // console.log("tmp", tmp)
                    // console.log("this.state.paths", this.state.paths)

                    // return
                    if (!this.state.isLoadingData) {
                        this.props.changeWindowLink(newLink)
                        // setTimeout(() => {
                        //     this.getFiles()
                        // }, 50);
                    }
                    // this.props.changeWindowLink(path)
                }
            )
        }

        // console.log(item)
        if (item.type == 'file') {
            let newLink
            newLink = this.props.baseUrl.splice(2, 1)
            newLink.push(this.props.page?._id)
            // newLink.push(item.link)
            let tmp = this.state.paths;
            tmp.push({ name: item.name, _id: item._id, link: item.link })
            this.setState({
                paths: tmp,
                currentItem: item,
                showContextMenu: false,
                current: ""
            },
                () => {
                    this.props.setData('paths', this.state.paths, 'Drive')

                    let path = []
                    tmp.forEach(el => {
                        if (el._id != null) {
                            // path.push(el._id)
                            path = [el.link]
                            newLink.push(el._id)
                        }
                    });
                    this.props.changeWindowLink(newLink)
                    this.changePage('single')
                    // this.getFiles()
                }
            )
        }
        // switch (item.type) {
        //     case 'folder':
        //         {
        //             let newLink
        //             newLink = this.props.baseUrl.splice(2)
        //             // newLink.push(item.link)
        //             let tmp = this.state.paths;
        //             tmp.push({ name: item.name, _id: item._id, link: item.link })
        //             this.setState({
        //                 paths: tmp,
        //                 currentItem: item,
        //                 showContextMenu: false,
        //                 current: ""
        //             },
        //                 () => {
        //                     let path = []
        //                     tmp.forEach(el => {
        //                         if (el._id != null) {
        //                             // path.push(el._id)
        //                             path = [el.link]
        //                             newLink.push(el.link)
        //                         }
        //                     });
        //                     this.props.changeWindowLink(newLink)
        //                     // this.props.changeWindowLink(path)
        //                     this.getFiles()
        //                 }
        //             )
        //         }
        //     case 'file':
        //         {
        //             let newLink
        //             newLink = this.props.baseUrl.splice(2)
        //             // newLink.push(item.link)
        //             let tmp = this.state.paths;
        //             tmp.push({ name: item.name, _id: item._id, link: item.link })
        //             this.setState({
        //                 paths: tmp,
        //                 currentItem: item,
        //                 showContextMenu: false,
        //                 current: ""
        //             },
        //                 () => {
        //                     let path = []
        //                     tmp.forEach(el => {
        //                         if (el._id != null) {
        //                             // path.push(el._id)
        //                             path = [el.link]
        //                             newLink.push(el._id)
        //                         }
        //                     });
        //                     this.props.changeWindowLink(newLink)
        //                     this.props.changeStagePage('single')
        //                     // this.getFiles()
        //                 }
        //             )
        //             // return;
        //         }
        // }
    }

    sortList = (key) => {
        let filteredFiles = this.state.filteredFiles
        let currentSort = this.state.currentSort
        let sorted = this.state.sorted
        if (key == 'name') {
            filteredFiles = filteredFiles.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 0)
            currentSort.type = 'name'
            if (currentSort.mode == 'ascending') {
                filteredFiles.reverse()
                currentSort.mode = 'descending'
            }
            else {
                currentSort.mode = 'ascending'
            }
        }
        else if (key == 'modifiedDate') {
            filteredFiles = filteredFiles.sort((a, b) => (a.uDate < b.uDate) ? 1 : (a.uDate > b.uDate) ? -1 : 0)
            currentSort.type = 'modifiedDate'
            if (currentSort.mode == 'ascending') {
                filteredFiles.reverse()
                currentSort.mode = 'descending'
            }
            else {
                currentSort.mode = 'ascending'
            }
            sorted = false
        }
        else if (key == 'type') {
            filteredFiles = filteredFiles.sort((a) => (a.type == 'file') ? 1 : (a.type == 'folder') ? -1 : 0)
            filteredFiles = filteredFiles.sort((a, b) => (a.extension > b.extension) ? 1 : (a.extension < b.extension) ? -1 : 0)
            currentSort.type = 'type'
            if (currentSort.mode == 'ascending') {
                filteredFiles.reverse()
                currentSort.mode = 'descending'
            }
            else {
                currentSort.mode = 'ascending'
            }
        }
        else if (key == 'size') {
            filteredFiles = filteredFiles.sort((a) => (a.type == 'file') ? 1 : (a.type == 'folder') ? -1 : 0)
            filteredFiles = filteredFiles.sort((a, b) => (a.size > b.size) ? 1 : (a.size < b.size) ? -1 : 0)
            currentSort.type = 'size'
            if (currentSort.mode == 'ascending') {
                filteredFiles.reverse()
                currentSort.mode = 'descending'
            }
            else {
                currentSort.mode = 'ascending'
            }
        }
        else if (key == 'createdDate') {
            filteredFiles = filteredFiles.sort((a, b) => (a.cDate < b.cDate) ? 1 : (a.cDate > b.cDate) ? -1 : 0)
            currentSort.type = 'createdDate'
            if (currentSort.mode == 'ascending') {
                filteredFiles.reverse()
                currentSort.mode = 'descending'
            }
            else {
                currentSort.mode = 'ascending'
            }
            sorted = false
        }
        else if (key == 'title') {
            filteredFiles = filteredFiles.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 0)
            currentSort.type = 'title'
            if (currentSort.mode == 'ascending') {
                // filteredFiles.reverse()
                currentSort.mode = 'descending'
            }
            else {
                currentSort.mode = 'ascending'
            }
            sorted = false
        }
        else if (key == 'ascending') {
            if (currentSort.mode = 'descending') {
                if (currentSort.type != 'title') {
                    filteredFiles.reverse()
                }
                currentSort.mode = 'ascending'
            }
        }
        else if (key == 'descending') {
            if (currentSort.mode = 'ascending') {
                if (currentSort.type != 'title') {
                    filteredFiles.reverse()
                }
                currentSort.mode = 'descending'
            }
        }
        this.setState({ filteredFiles, currentSort, sorted })
    }

    filterFiles = (value) => {
        let filteredFiles = this.state.driveInfo.filter((e) => e.name.toLowerCase().substring(0, value.length) == value.toLowerCase())
        this.setState({ filteredFiles })
    }

    setStateProps = (key, value) => {
        this.setState({ [key]: value })
    }

    changeTab = (prop, index) => {
        let { frame, viewType } = this.state
        viewType = prop.key
        frame = prop.label
        this.setState({ viewType }, () => {
            this.getFiles();
        })
        this.setState({ frame })
    }

    _handleSubmit(e) {
        e.preventDefault();
    }

    _handleChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({
                file: file,
                Url: reader.result
            });
        }
    }

    setViewType = (view) => {

        let viewType

        let driveSections = this.state.driveSections

        driveSections.forEach(section => {
            if (section.key == view) {
                viewType = section
            }
        });
        if (!viewType) {
            viewType = driveSections[0]
        }

        this.setState({ viewType }, () => {

            this.props.setHeader('viewType', viewType)

            if (this.stageManager) {
                this.stageManager.changeStage('directoryViewer')
                if (viewType.key == 'sharedWithMe') {
                    this.getSharedFiles()
                } else {
                    this.getFiles()
                }
            }

        })
        // })
    }

    handleUpload = (files) => {
        this.setState({ upload: true })
        this.uploadingmodal.showModal()
    }

    showDropZone = () => {
        this.setState({ upload: true })
        this.uploadingmodal.showModal()
    }

    emptyCurrentItem = () => {
        this.setState({ currentItem: "" })
    }



    restoreFromTrash = () => {
        this.moveToTrash(false)
    }

    openPreview = (item) => {
        this.previewModal.showModal()
    }

    onProperties = (item) => {
        // console.log('*onProperties', item)
        if (!item) {
            item = this.state.folderInfo
        }
        // console.log('this.state.folder', this.state.folderInfo)
        this.setState({ currentItem: item })
        this.setState({ showContextMenu: false, showConfig: true })
        this.sidebarView.open()
    }

    onDeleteItem = (a, b, c) => {
        // console.log(a,b,c)
        this.deleteConfirmation()
    }

    onOpenItem = () => {
        let currentItem = this.state.currentItem
        this.onClickItem(currentItem)
    }

    onCopyItem = () => {
        const { currentItem } = this.state;
        this.setState({ copyItem: currentItem._id, showContextMenu: false, current: "" })
    }

    onRenameItem = () => {
        let currentItem = this.state.currentItem
        this.setState({ renameItem: currentItem._id, showContextMenu: false })
    }

    handleCopy = (item) => {
        // console.log('*handleCopy', item)
        navigator.clipboard.writeText(item);
        this.props.actions.addNotif({ type: 'success', title: 'Successfuly Copied!', description: 'Information Successfuly Copied.' })
    }

    setLink = (item, cb) => {
        // let currentItem = this.state.currentItem
        // let link = this.state.link
        let link = siteConfig.rootDomain

        // let windowData = this.props.windowData
        // if (this.props.isApplet) {
        //     // console.log('windowData.path.length', windowData.path.length, this.props.baseUrl.length)
        //     windowData.path.forEach((el, index) => {
        //         if (index != this.props.baseUrl.length) {
        //             if (el != 'admin') {
        //                 link = link + el + '/'
        //             }
        //         }
        //     });
        //     // console.log('this.kli', link)

        // }
        // else {
        //     //user applet
        //     link = link + item.appletHub.username + '/' + item.applet.urlcode + '/' + this.props.page._id + '/'
        // }
        link = link + "drive/" + item.type + '/' + item.link
        // console.log(link)
        this.setState({ link }, () => {
            if (cb) {
                cb()
            }
        })
    }

    changePage = (stage) => {
        if (this.stageManager) {
            this.stageManager.changeStage(stage)
        }
    }

    setCurrentApplet = (key, value, cb) => {
        this.props.setCurrentApplet(key, value, () => {
            this.props.setData('error', null, 'Drive')
            // console.log('key,value', key, value, '00000')
            if (key == 'currentApplet') {
                this.props.changePage(value, null, true)
            }
            // let filteredFiles = []
            // let newLink
            // newLink = this.props.baseUrl.splice(2, 1)
            // if (this.props.currentApplet == '') {
            //     filteredFiles = this.state.driveInfo
            // }
            // else {
            //     newLink.push(this.props.currentApplet)
            //     this.state.driveInfo.map((prop) => {
            //         if (prop?.applet == this.props.currentApplet) {
            //             filteredFiles.push(prop)
            //         }
            //     })
            // }
            // // this.onChangeDirectory(0)
            // this.props.changeWindowLink(newLink)
            // this.setState({ filteredFiles }, () => {
            //     this.getFiles()
            //     if (cb) {
            //         cb()
            //     }
            // })
        })
    }


    createDoc = (cb) => {

        let folder
        if (this.props.windowData.path?.length > this.props.baseUrl?.length) {

            folder = this.props.windowData.path[this.props.baseUrl?.length]
            if (folder == 'folder') {
                folder = this.props.windowData.path[this.props.baseUrl?.length + 1]
            }

        }
        let body = {
            frame: this.props.page?._id,
            folder
        }

        // console.log(body)
        // return

        HttpServices.request('createDoc', body, (fetchResult, fetchError) => {

            console.log(fetchResult, fetchError)

            if (fetchError) {
                if (cb) { cb(null, true) }
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadingFailed', description: fetchError.message })
                return
            }

            if (cb) { cb() }

            this.openNote(fetchResult.info)




        })
    }

    openNote = (item) => {

        // console.log(item)
        // let newLink = this.props.baseUrl.splice(2, 1)
        // if (!this.props.isApplet) {
        //     newLink.push(item.applet?._id ?? item.applet)
        // }
        // newLink.push(this.props.page?._id)
        // // newLink.push(item.link)
        // let paths = this.state.paths;
        // let tmp = [paths[paths.length - 1]]
        // if (paths[0].name != 'Drive' && paths[0]._id == null) {
        //     paths.push({ name: 'Drive', _id: null, link: null })
        // }
        // if (paths[paths.length - 1]._id != item._id) {
        //     // paths.push({ name: item.name, _id: item._id, link: item.link })
        //     tmp.push({ name: item.name, _id: item._id, link: item.link })
        // }
        this.setState({
            // paths,
            currentItem: item,
            showContextMenu: false,
            current: ""
        },
            () => {
                this.props.setData('paths', this.state.paths, 'Drive')

                // let path = []
                // tmp.forEach(el => {
                //     if (el._id != null) {
                //         // path.push(el._id)
                //         path.push(el.link)
                //         newLink.push(el.link)
                //     }
                // });
                let newLink = ['doc', item.link]
                if (!this.state.isLoadingData) {
                    this.props.changeWindowLink(newLink)
                }
                // this.props.changeWindowLink(path)
            }
        )
        // this.props.setData('currentNote', item, 'Drive', () => {
        //     this.props.getNote()
        // })
    }
    // setCurrentApplet = (key, value, cb) => {
    //     this.setState({ [key]: value }, () => {
    //         let filteredFiles = []
    //         if (this.state.currentApplet == '') {
    //             filteredFiles = this.state.driveInfo
    //         }
    //         else {
    //             this.state.driveInfo.map((prop) => {
    //                 if (prop?.applet == this.state.currentApplet) {
    //                     filteredFiles.push(prop)
    //                 }
    //             })
    //         }
    //         this.setState({ filteredFiles }, () => {
    //             this.getFiles()
    //             if (cb) {
    //                 cb()
    //             }
    //         })
    //     })
    // }

    // openNote = () => {
    //     this.props.changeStagePage('editor')
    // }

    render() {
        const { contextMenu, copyItem, currentItem, current } = this.state
        return (
            <div ref={el => this.container = el} className={"filemanager w-100 h-100 "} style={{ backgroundColor: '#fff', overflow: 'hidden' }}>
                {!this.props.error || !this.props.error?.applet ? (

                    <div className='w-100 h-100 filemanager-page window-content-radius'>
                        <div ref={el => this.cornerDiv = el} style={{ position: 'fixed', top: 0, left: 0, width: 1, height: 1 }}></div>
                        <SidebarView width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: "80%", sm: "60%", md: '35%', lg: "35%", xl: "30%" }}>
                            <PropertiesView
                                page={this.props.page}
                                dynamicActions={this.state.exploreActions}
                                currentItem={this.state.currentItem}
                                paths={this.state.paths}
                                openShareModal={this.openShareModal}
                                isApplet={this.props.isApplet}
                                width={this.props.width}
                                adminView={this.props.adminView}
                                applet={this.props.applet}
                                currentApplet={this.props.currentApplet}
                                language={this.props.language}
                                colors={this.props.colors}
                                functionsHandler={this.functionsHandler}
                                close={() => this.sidebarView.close()}
                            />
                        </SidebarView>
                        <ContextMenu
                            page={this.props.page}
                            actions={this.state.exploreActions}
                            adminView={this.props.adminView}
                            functionsHandler={this.functionsHandler}
                            isApplet={this.props.isApplet}
                            applet={this.props.applet}
                            show={this.state.showContextMenu}
                            currentItem={this.state.currentItem}
                            ref={this.contextMenueRef}
                            showPaste={copyItem != null}
                            copyItem={this.state.copyItem}
                            view={contextMenu.view}
                            frame={this.state.frame}
                            style={{ top: `${contextMenu.yPos}px`, left: `${contextMenu.xPos}px`, zIndex: 10 }}
                            folderModal={this.folderModal}
                            onDeleteItem={this.deleteConfirmation}
                            onCopyItem={this.onCopyItem}
                            starred={this.state?.starred}
                            onStar={this.onStar}
                            onRenameItem={this.onRenameItem}
                            onPasteItem={this.onPasteItem}
                            onOpenItem={this.onClickItem}
                            onProperties={this.onProperties}
                            contextMenu={this.state.contextMenu}
                            restoreFromTrash={this.restoreFromTrash}
                            shareModal={this.shareModal}
                            lockingModal={this.lockModal}
                            lockModal={this.lockModal}
                            language={this.props.language}
                            viewType={this.state.viewType}
                        />
                        <div ref={el => this.scrollContainer = el} className='w-100' style={{ height: `100%` }}>
                            <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                                <div stage={0} stageName='directoryViewer' className="h-100 w-100 scroll-no-scrollbar" style={{}}>
                                    {this.state.isLoadingFiles ? (
                                        <div className={conditionalWidth(this.props.width, { xs: 'h-100 w-100 flexcc', sm: 'h-100 w-100 flexcc', md: "h-100 w-100 flexcc", lg: "h-100 w-100 flexcc", xl: "h-100 w-100 flexcc" })} style={{}}>
                                            <CustomLoader color="#ff8500" isLoading={this.state.isLoadingFiles} />
                                        </div>
                                    ) : (
                                        this.state.isLoadingData ? (
                                            <div className={conditionalWidth(this.props.width, { xs: 'h-100 w-100 flexcc', sm: 'h-100 w-100 flexcc', md: "h-100 w-100 flexcc", lg: "h-100 w-100 flexcc", xl: "h-100 w-100 flexcc" })} style={{}}>
                                                <CustomLoader color="#ff8500" isLoading={this.state.isLoadingData} />
                                            </div>
                                        ) : (
                                            <div className='h-100'>
                                                {/* <div> */}
                                                {/* {this.state.paths.length == 1 && (
                                                <FileManagerRecents language={this.props.language} uploadModal={this.uploadModal} />
                                                 )} */}
                                                {/* </div> */}
                                                <div onDragEnter={(e) => this.showDropZone(e, '0')} className='h-100'>
                                                    <Dropzone ref={el => this.dropzoneRef = el} multiple={true} onDrop={(e) => this.handleUpload(e, false)} className="h-100" style={{ flex: 1, cursor: 'pointer', outline: 'none' }}>
                                                        {({ getRootProps, getInputProps }) => (
                                                            <div {...getRootProps()} onDragLeave={this.onDragLeave} className='h-100'>
                                                                {/* {console.log(this.state.filteredFiles)} */}
                                                                <DirectoryViewer
                                                                    renameItem={this.state.renameItem}
                                                                    openNote={this.openNote}
                                                                    currentItem={this.state.currentItem}
                                                                    current={current}
                                                                    filteredFiles={this.state.filteredFiles}
                                                                    onClickItem={this.onClickItem}
                                                                    width={this.props.width}
                                                                    view={this.state.view}
                                                                    page={this.props.page}
                                                                    dynamicActions={this.state.exploreActions}
                                                                    functionsHandler={this.functionsHandler}
                                                                    onRightClickItem={this.onRightClickItem}
                                                                    onProperties={this.onProperties}
                                                                    changeWindowLink={this.props.changeWindowLink}
                                                                    onRenameItem={this.onRename}
                                                                    itemActions={this.state.itemActions}
                                                                />
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                                <FileSinglePage stageName='single' stage={1} db={this.props.db} windowData={this.props.windowData} height={'100%'} width={this.props.width}
                                    applets={this.props.applets}
                                    changeAppletsTab={this.props.changeAppletsTab} language={this.props.language}
                                    adminView={this.props.adminView} isApplet={this.props.isApplet} currentApplet={this.props.currentApplet} applet={this.props.applet} variables={this.props.variables} goToHub={this.props.goToHub}
                                    colors={this.props.colors} changeWindowLink={this.props.changeWindowLink}
                                    isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions}
                                    baseUrl={this.props.baseUrl} lastSelected={this.props.lastSelected} changeWindow={this.props.changeWindow}
                                    selectApplet={this.props.selectApplet}
                                    initData={this.props.initData}
                                    data={this.props.data}
                                    page={this.props.page}
                                    setData={this.props.setData}
                                    route={this.props.route}
                                    setWindowInfo={this.props.setWindowInfo}
                                    changePage={this.changePage}

                                    renameItem={this.state.renameItem}
                                    currentItem={this.state.currentItem}
                                    current={current}
                                    filteredFiles={this.state.filteredFiles}
                                    onClickItem={this.onClickItem}
                                    view={this.state.view}
                                    dynamicActions={this.state.exploreActions}
                                    functionsHandler={this.functionsHandler}
                                    onRightClickItem={this.onRightClickItem}
                                    onProperties={this.onProperties}
                                    onRenameItem={this.onRename}
                                    itemActions={this.state.itemActions}

                                    shareModal={this.shareModal}
                                />
                            </StagesManager>
                        </div>
                    </div >
                ) : <div className='pt-5'>{translate("Applet is not valid")}</div>
                }

                <Modal maxWidth={400} className="" ref={(foldermodal) => this.createNewFoldermodal = foldermodal} onHide={() => this.setState({ newFolder: false })}>
                    <div className='d-flex w-100 h-100 window-content-radius flexcc'>
                        <div className="createFolderModal w-100 p-3" style={{}}>
                            <div className="flexcc" style={{ justifyContent: 'flex-start' }}>
                                <img style={{}} className="mrd-1" width={25} alt="" src='/assets/icons/applets/drive/drive-folder.svg'></img>
                                <p className="text-normal  mt-1" style={{ color: '#222' }}>{translate('drives.Create New Folder')}</p>
                            </div>
                            <div className="modal-input pt-3" style={{ justifyContent: 'left' }}>
                                <input id="folderNameInput" type='text' autoFocus={true} onChange={(e) => this.changeInputValue(e)} ref={this.inputFolder} placeholder={translate("drives.Folder's name")} className="newFolderName" />
                            </div>
                            {this.state.errorName &&
                                <div className="">
                                    <p className=" text-smallest " style={{ color: '#dc2f18' }}>{translate('drives.This name is exist. Please try another name.')}</p>
                                </div>
                            }
                            <div className="flexcb" style={{ justifyContent: 'center' }}>
                                <div className="flexc w-100 pt-2" style={{ justifyContent: 'flex-end' }}>
                                    <div className="flexc mrd-2">
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={() => (this.createNewFoldermodal.hideModal(), this.setState({ errorName: false }))}
                                            title={translate('drives.Cancel')}
                                            textColor={'#a3a2b0'}
                                            bg={'#eee'}
                                        />
                                    </div>
                                    <div className="flexc mld-2">
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={() => (this.createDirectory(), this.setState({ errorName: false }))}
                                            title={translate('drives.Create')}
                                            icon='/assets/icons/angle-right-white2.svg'
                                            textColor={'#fff'}
                                            bg={this.props.colors ? this.props.colors.background : '#c83418'}
                                        />
                                    </div>
                                </div>
                                {/* <button className="modalCancelButton mrd-1" onClick={() => (this.createNewFoldermodal.hideModal(), this.setState({ errorName: false }))}>
                                    {translate('drives.Cancel')}
                                </button>
                                <button className='modalCreateButton mld-1' onClick={() => (this.createDirectory(), this.setState({ errorName: false }))}>
                                    {translate('drives.Create')}
                                </button> */}
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal maxWidth={400} ref={(deletemodal) => this.confirmMoveToTrashModal = deletemodal}  >
                    <div className="w-100  " style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                        <div className="p-4">
                            <p className="text-normal weight-600 pb-3" style={{}}>{translate("Are you sure you want to remove?")}</p>
                            <p className="text-small weight-500 main-c7" style={{}}>{translate('drives.rethink-your-decision')}</p>
                            <div className="flexc w-100 pt-4" style={{ justifyContent: 'flex-end' }}>
                                <div className="flexc mrd-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { this.confirmMoveToTrashModal.hideModal(); this.setState({ deleteItem: true }) }}
                                        title={translate('drives.Cancel')}
                                        textColor={'#a3a2b0'}
                                        bg={'#eee'}
                                    />
                                </div>
                                <div className="flexc mld-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => this.moveToTrash(true)}
                                        title={translate('drives.Delete')}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        textColor={'#fff'}
                                        bg={`linear-gradient(90deg, #ef0b0bdd, #ef0b0bdd)`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal maxWidth={400} ref={(uploadmodal) => this.uploadingmodal = uploadmodal}>
                    <div className="bg-white br-10  scroll-no-scrollbar" style={{ maxHeight: '90%' }} >
                        <Uploader currentHub={this.props.currentHub} applet={(this.props.currentApplet && this.props.currentApplet != '') ? this.props.currentApplet : this.props.applet?._id} getFiles={this.getFiles} paths={this.state.paths} hideUploadModal={this.hideUploadModal} colors={this.props.colors} page={this.props.page} />
                    </div>
                </Modal>
                {/* <div className='brt-5 box-shadow-20' style={{ position: 'absolute', bottom: 0, right: 10, zIndex: 10, backgroundColor: '#fff', width: conditionalWidth(this.props.width, { xs: '100%', sm: '80%', md: '50%', lg: '40%', xl: '30%' }) }}>
                    <div className='brt-5 px-2 py-2 flexcb' style={{ background: this.props.colors ? this.props.colors.background : '#f7f9fc', overflow: 'hidden' }}>
                        <p style={{ color: this.props.colors ? this.props.colors.textColor : '#222' }}>Uploading <span>{this.props.queque?.uploads?.length}</span> {this.props.queque?.uploads?.length > 1 ? translate('items') : translate('item')}</p>
                        <img src={importedIcons.arrowUp} onClick={() => { this.setState({ openCollapse: !this.state.openCollapse }) }} />
                    </div>
                    <Collapsible open={this.state.openCollapse ?? true}>
                        <div className='my-1'>
                            {this.props.queque?.uploads?.map((item, index) => {
                                return (
                                    <div className='w-100 my-1' key={index}>
                                        <button onClick={() => this.changeFrame(item)} className='flexc w-100 p-2 hover-gray br-5 transition-all'>
                                            <div className='flexcc'>
                                                <img className="transition-all" src={item.icon ?? '/assets/icons/applets/general/play-games.png'} height={22} />
                                            </div>

                                            <div className='mld-3'>
                                                <p className='font-size-12 main-c3 '>{checkTranslation(item.file?.name)}</p>
                                            </div>
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                    </Collapsible>
                    <div>
                        <p>1</p>
                        <p>2</p>
                        <p>3</p>
                    </div>
                </div> */}
                <Modal maxWidth={400} ref={(lockModal) => this.lockingModal = lockModal}  >
                    <div className="bg-white br-10 w-100 scroll-no-scrollbar" style={{ maxHeight: '90%' }} >
                        <div className="p-3 w-100">
                            <div className="pb-2 w-100">
                                <p className="font-size-14 main-c3">{translate('drives.Lock-modal')}<span>{this.state.currentItem?.name}</span>'</p>
                            </div>
                            <div className="py-3 w-100">
                                <input ref={e => this.inputShare = e} className="py-1 modern-input4 px-2 w-100" rows={1} placeholder={translate("drives.Set a Password")} id="" autoFocus={true} style={{ zIndex: 3 }} />
                            </div>
                            <div className="flexcb pt-4" style={{ justifyContent: 'center' }}>
                                <button className="br-5 mrd-1 gray-btn py-2 w-100" onClick={() => { this.confirmMoveToTrashModal.hideModal(); this.setState({ deleteItem: true }) }}>
                                    <p className="font-size-14">{translate('drives.Cancel')}</p>
                                </button>
                                <button className="submit-btn br-5 mld-1 py-2 w-100" onClick={() => this.moveToTrash(true)}>
                                    <p className="white font-size-14">{translate('drives.Lock')}</p>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <ShareModal ref={el => this.shareModal = el} variables={this.props.variables} setLink={this.setLink} updateFile={this.updateFile} link={this.state.link} currentItem={this.state.currentItem} colors={this.props.colors} applet={this.props.applet} currentApplet={this.props.currentApplet} data={this.props.data} setData={this.props.setData} windowData={this.props.windowData} handleCopy={this.handleCopy} copyLink={this.copyLink} />
                <Modal maxWidth={800} ref={(templatemodal) => this.templatesModal = templatemodal} zIndex={10} className={'flexcc'} noScroll={true} modalContentClassName={'h-100'} marginBottom={'5%'}>
                    <div className="shareModal d-flex flex-column w-100 h-100 window-content-radius">
                        <Templates width={this.props.width} />
                    </div>
                </Modal>


                <Modal className="" ref={(el) => this.previewModal = el} >
                    <FilePreview data={this.state.currentItem} />
                </Modal>
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, queque: state.queque })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FileManager);